import React, { useEffect, useState } from "react";
import { Range, getTrackBackground } from "react-range";
import css from "./slider.module.css";
import { ReactComponent as SetaDir } from "../../../../../assets/icons/arrow/seta_dir.svg";
import { ReactComponent as SetaEsq } from "../../../../../assets/icons/arrow/seta_esq.svg";
import useMediaQuery from "../../../../hooks/useMediaQuery ";
const STEP = 1;

export default function AnoSlider({
  ArrayCarros,
  UpdateInicial,
  UpdateFinal,
  PesquisaAnoInicial,
  PesquisaAnoFinal,
  infoJson,
}) {
  const ismobile = useMediaQuery("(max-width: 767px)");
  const [values, setValues] = useState([1900, 3000]);
  const [MIN, setMIN] = useState(1900);
  const [MAX, setMAX] = useState(3000);

  useEffect(() => {
    const min = Math.min.apply(
      Math,
      ArrayCarros.filter((carro) => {
        return carro.Vendido === false;
      }).map(function (o) {
        return o.Ano;
      })
    );

    setMIN(min);

    const max = Math.max.apply(
      Math,
      ArrayCarros.filter((carro) => {
        return carro.Vendido === false;
      }).map(function (o) {
        return o.Ano;
      })
    );

    setValues([
      PesquisaAnoInicial !== "" ? PesquisaAnoInicial : min,
      PesquisaAnoFinal !== "" ? PesquisaAnoFinal : max,
    ]);
    setMAX(max);
  }, [ArrayCarros, PesquisaAnoInicial, PesquisaAnoFinal]);

  const handlerValue = (values) => {
    setValues(values);
    UpdateInicial(values[0]);
    UpdateFinal(values[1]);
  };

  return (
    <>
      {ismobile && (
        <output className={`${css.values}`}>
          de {values[0]} até {values[1]}
        </output>
      )}
      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        onChange={(values) => handlerValue(values)}
        renderTrack={({ props, children }) => (
          <div
            //  onMouseDown={props.onMouseDown}
            //  onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
            }}
            className={css.rectangle}
          >
            <div
              ref={props.ref}
              style={{
                height: "2px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values,
                  colors: ["#ccc", `${infoJson.Cores.Principal}`, "#ccc"],
                  min: MIN,
                  max: MAX,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ index, props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
            }}
            className={`${css.box} box-slider`}
          >
            {ismobile ? (
              <div className={`${css.arrow}`}>
                <SetaEsq stroke={isDragged ? "#b9b9b9" : "#fff"} />
                <SetaDir stroke={isDragged ? "#b9b9b9" : "#fff"} />
              </div>
            ) : (
              <div className={`${css.number}`}>{values[index]}</div>
            )}
          </div>
        )}
      />
    </>
  );
}
